module.exports = __webpack_public_path__ + "img/mclaren.f921e59a.png";